import { call, put, takeEvery } from "redux-saga/effects";
import { getRequest } from "../../app/request";
import { failurePut } from "../../app/failurePut";
import {
    getAchievementsAction,
    getAchievementsFailure,
    getAchievementsPreviewAction,
    getAchievementsPreviewFailure,
    getAchievementsPreviewSuccess,
    getAchievementsProgressAction,
    getAchievementsProgressFailure,
    getAchievementsProgressSuccess,
    getAchievementsSuccess
} from "./achievementsReducer";

function* getAchievementsSaga() {
    try {
        const data = yield call(getRequest, "/user/achievements");
        yield put(getAchievementsSuccess(data));
    } catch (e) {
        yield call(failurePut, e, getAchievementsFailure);
    }
}

function* getAchievementsPreviewSaga() {
    try {
        const data = yield call(getRequest, "/user/achievements/preview");
        yield put(getAchievementsPreviewSuccess(data));
    } catch (e) {
        yield call(failurePut, e, getAchievementsPreviewFailure);
    }
}

function* getAchievementsProgressSaga() {
    try {
        const data = yield call(getRequest, "/user/achievements/progress");
        yield put(getAchievementsProgressSuccess(data));
    } catch (e) {
        yield call(failurePut, e, getAchievementsProgressFailure);
    }
}

export function* achievementsSagas() {
    yield takeEvery(getAchievementsAction, getAchievementsSaga);
    yield takeEvery(getAchievementsPreviewAction, getAchievementsPreviewSaga);
    yield takeEvery(getAchievementsProgressAction, getAchievementsProgressSaga);
}
